exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".settings-icon-1{fill:#f1faf9}.settings-icon-2{fill:#bfe7e3}.settings-icon-3{fill:#1e4e69}\n", ""]);
